export const mapDivContainer = {
  height: '100%',
  width: '100%',
  overflow: 'visible',
}

export const map = {
  height: '100%',
  width: '100%',
  position: 'absolute',
}

export default {
  map,
  mapDivContainer,
}
